module.exports = __webpack_public_path__ + "img/22.b7989ee0.jpg";